import { Union, Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { CustomerInfo_$reflection, Dashboard_CustomerUsageSummary_$reflection, Dashboard_UsageSummary_$reflection, Dashboard_UsageEntry_$reflection } from "../Shared/ApiDataTypes.js";
import { int32_type, obj_type, union_type, record_type, string_type, bool_type, option_type, array_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { FetchError, FetchError_$reflection } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { testRedirect, extraCoders } from "../Promises.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { singleton as singleton_1, cons, ofArray, empty } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { unwrap, map, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { toString } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { createObj, uncurry2 } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { API_Dashboard_CustomerUsage } from "../Shared/Urls.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { join } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { empty as empty_1, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { DialogActions, Button, DialogContent, DialogTitle, Dialog, Skeleton, Typography } from "@mui/material";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { sortBy, map as map_1 } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { compare, toShortDateString } from "../fable_modules/fable-library-js.4.24.0/Date.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ResponsiveContainer, LineChart, Line, XAxis, Tooltip, YAxis } from "recharts";
import { Search as Search_1 } from "../CustomerSearch.js";
import { ctx as ctx_1 } from "../Context.js";
import { useEffectOnce } from "../fable_modules/Feliz.2.8.0/Internal.fs.js";
import { SnackError } from "../ViewHelpers.js";
import { Components_Button_Z1043B8E } from "../Components/Button.js";
import Person from "@mui/icons-material/Person";
import Search_2 from "@mui/icons-material/Search";

class Model extends Record {
    constructor(Daily, Summary, CustomerUsage, SelectedCustomer, Search, ErrorMsg) {
        super();
        this.Daily = Daily;
        this.Summary = Summary;
        this.CustomerUsage = CustomerUsage;
        this.SelectedCustomer = SelectedCustomer;
        this.Search = Search;
        this.ErrorMsg = ErrorMsg;
    }
}

function Model_$reflection() {
    return record_type("Dashboards.UserActivity.Model", [], Model, () => [["Daily", option_type(array_type(Dashboard_UsageEntry_$reflection()))], ["Summary", option_type(Dashboard_UsageSummary_$reflection())], ["CustomerUsage", option_type(Dashboard_CustomerUsageSummary_$reflection())], ["SelectedCustomer", option_type(CustomerInfo_$reflection())], ["Search", bool_type], ["ErrorMsg", option_type(string_type)]]);
}

class Message extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["DailyResponse", "SummaryResponse", "CustomerUsageResponse", "SelectCustomer", "ToggleSearch", "DismissError"];
    }
}

function Message_$reflection() {
    return union_type("Dashboards.UserActivity.Message", [], Message, () => [[["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Dashboard_UsageEntry_$reflection()), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(Dashboard_UsageEntry_$reflection())]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Dashboard_UsageSummary_$reflection(), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", Dashboard_UsageSummary_$reflection()]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Dashboard_CustomerUsageSummary_$reflection(), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", Dashboard_CustomerUsageSummary_$reflection()]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", CustomerInfo_$reflection()]], [["Item", bool_type]], []]);
}

function init() {
    return new Model(undefined, undefined, undefined, undefined, false, undefined);
}

function update(model, msg) {
    switch (msg.tag) {
        case 1: {
            const res_1 = msg.fields[0];
            if (res_1.tag === 1) {
                return new Model(model.Daily, model.Summary, model.CustomerUsage, model.SelectedCustomer, model.Search, "Kunne ikke laste brukerstatistikk. Vennligst prøv igjen senere.");
            }
            else {
                return new Model(model.Daily, res_1.fields[0], model.CustomerUsage, model.SelectedCustomer, model.Search, model.ErrorMsg);
            }
        }
        case 2: {
            const res_2 = msg.fields[0];
            if (res_2.tag === 1) {
                return new Model(model.Daily, model.Summary, model.CustomerUsage, model.SelectedCustomer, model.Search, "Kunne ikke laste kundestatistikk. Vennligst prøv igjen senere.");
            }
            else {
                return new Model(model.Daily, model.Summary, res_2.fields[0], model.SelectedCustomer, model.Search, model.ErrorMsg);
            }
        }
        case 3:
            return new Model(model.Daily, model.Summary, model.CustomerUsage, msg.fields[0], false, model.ErrorMsg);
        case 4:
            return new Model(model.Daily, model.Summary, model.CustomerUsage, model.SelectedCustomer, msg.fields[0], model.ErrorMsg);
        case 5:
            return new Model(model.Daily, model.Summary, model.CustomerUsage, model.SelectedCustomer, model.Search, undefined);
        default: {
            const res = msg.fields[0];
            if (res.tag === 1) {
                return new Model(model.Daily, model.Summary, model.CustomerUsage, model.SelectedCustomer, model.Search, "Kunne ikke laste brukerstatistikk. Vennligst prøv igjen senere.");
            }
            else {
                return new Model(res.fields[0], model.Summary, model.CustomerUsage, model.SelectedCustomer, model.Search, model.ErrorMsg);
            }
        }
    }
}

function fetchDaily(customerId, dispatch) {
    const pr_2 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let pr_1, decoder, data_1, caseStrategy_2, extra_2;
        const requestPath = `${"/api/dashboard/daily-users"}${(customerId != null) ? (`?customer=${customerId}`) : ""}`;
        return ((pr_1 = ((decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Dashboard_UsageEntry_$reflection()), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = extraCoders, (() => {
            let properties_2;
            try {
                const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(requestPath, properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Dashboard_UsageEntry_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
            }
            catch (exn) {
                return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
        })()))))), pr_1.then((result_1) => Result_MapError(testRedirect, result_1)))).then((_arg_2) => {
            dispatch(new Message(0, [_arg_2]));
            return Promise.resolve();
        });
    }));
    pr_2.then();
}

function fetchSummary(customerId, dispatch) {
    const pr_2 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let pr_1, decoder, data_1, caseStrategy_2, extra_2;
        const requestPath = `${"/api/dashboard/usage-summary"}${(customerId != null) ? (`?customer=${customerId}`) : ""}`;
        return ((pr_1 = ((decoder = Auto_generateBoxedDecoder_Z6670B51(Dashboard_UsageSummary_$reflection(), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = extraCoders, (() => {
            let properties_2;
            try {
                const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(requestPath, properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(Dashboard_UsageSummary_$reflection(), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
            }
            catch (exn) {
                return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
        })()))))), pr_1.then((result_1) => Result_MapError(testRedirect, result_1)))).then((_arg_2) => {
            dispatch(new Message(1, [_arg_2]));
            return Promise.resolve();
        });
    }));
    pr_2.then();
}

function fetchCustomerUsage(customerId, dispatch) {
    const pr_2 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let pr_1, decoder, data_1, caseStrategy_2, extra_2;
        const requestPath = API_Dashboard_CustomerUsage(customerId);
        return ((pr_1 = ((decoder = Auto_generateBoxedDecoder_Z6670B51(Dashboard_CustomerUsageSummary_$reflection(), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = extraCoders, (() => {
            let properties_2;
            try {
                const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(requestPath, properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(Dashboard_CustomerUsageSummary_$reflection(), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
            }
            catch (exn) {
                return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
        })()))))), pr_1.then((result_1) => Result_MapError(testRedirect, result_1)))).then((_arg_2) => {
            dispatch(new Message(2, [_arg_2]));
            return Promise.resolve();
        });
    }));
    pr_2.then();
}

function drawSummary(locale, model) {
    let elems_1;
    const infoBox = (title, v) => {
        let elems;
        return createElement("div", createObj(ofArray([["className", join(" ", ["gray-rounded-container"])], ["style", {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
        }], (elems = toList(delay(() => append(singleton(MuiHelpers_createElement(Typography, [["noWrap", true], ["variant", "h6"], ["children", title]])), delay(() => {
            const matchValue = model.Summary;
            return (matchValue != null) ? singleton(MuiHelpers_createElement(Typography, [["variant", "h3"], ["children", v(matchValue)]])) : singleton(MuiHelpers_createElement(Skeleton, [["variant", "rectangular"], ["height", 30]]));
        })))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
    };
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 30 + "px",
        width: 100 + "%",
    }], (elems_1 = toList(delay(() => append(singleton(infoBox(locale.t("Dashboard.Usage.UsersToday"), (a) => a.Today)), delay(() => append((model.SelectedCustomer == null) ? singleton(infoBox(locale.t("Dashboard.Usage.UsersLastSeven"), (a_1) => a_1.LastSeven)) : empty_1(), delay(() => append(singleton(infoBox(locale.t("Dashboard.Usage.UsersThisWeek"), (a_2) => a_2.ThisWeek)), delay(() => singleton(infoBox(locale.t("Dashboard.Usage.UsersLastWeek"), (a_3) => a_3.PreviousWeek)))))))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function drawCustomerSummary(locale, model) {
    let elems_1;
    const infoBox = (title, v) => {
        let elems;
        return createElement("div", createObj(ofArray([["style", {
            border: (((1 + "px ") + "solid") + " ") + "#dedede",
            borderRadius: 4,
            padding: 10,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: 100 + "%",
            maxWidth: 220,
        }], (elems = toList(delay(() => append(singleton(createElement("span", {
            style: {
                fontSize: 0.8 + "rem",
            },
            children: title,
        })), delay(() => {
            const matchValue = model.CustomerUsage;
            if (matchValue != null) {
                const s = matchValue;
                return singleton(createElement("span", {
                    style: {
                        fontWeight: "bold",
                        fontSize: 2 + "rem",
                        margin: 10,
                    },
                    children: v(s),
                }));
            }
            else {
                return singleton(MuiHelpers_createElement(Skeleton, [["variant", "rectangular"], ["height", 30]]));
            }
        })))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
    };
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: 1 + "vw",
        flexWrap: "wrap",
        width: 100 + "%",
    }], (elems_1 = [infoBox(locale.t("Dashboard.Usage.UsersLastWeek"), (a) => a.LastWeek), infoBox(locale.t("Dashboard.Usage.UsersLastMonth"), (a_1) => a_1.LastMonth), infoBox(locale.t("Dashboard.Usage.UsersLastYear"), (a_2) => a_2.LastYear)], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export class Point extends Record {
    constructor(Dato, Antall) {
        super();
        this.Dato = Dato;
        this.Antall = (Antall | 0);
    }
}

export function Point_$reflection() {
    return record_type("Dashboards.UserActivity.Point", [], Point, () => [["Dato", string_type], ["Antall", int32_type]]);
}

function drawDailyUsage(locale, model) {
    let elems_1;
    return createElement("div", createObj(ofArray([["className", join(" ", ["bordered-container"])], ["style", {
        display: "flex",
        flexDirection: "column",
        width: 100 + "%",
    }], (elems_1 = toList(delay(() => {
        const matchValue = model.Daily;
        if (matchValue != null) {
            const data = map_1((d_1) => (new Point(toShortDateString(d_1.Date), d_1.Num)), sortBy((d) => d.Date, matchValue, {
                Compare: compare,
            }));
            return append(singleton(MuiHelpers_createElement(Typography, [["variant", "h6"], ["style", {
                textAlign: "center",
            }], ["children", locale.t("Dashboard.Usage.UsersPerDay")]])), delay(() => {
                let properties_8, properties_7, elements;
                return singleton((properties_8 = ofArray([["minHeight", 250 + "px"], ["children", (properties_7 = ofArray([["width", 800], ["data", data], ["margin", {
                    top: defaultArg(5, 0),
                    right: defaultArg(30, 0),
                    left: defaultArg(50, 0),
                    bottom: defaultArg(5, 0),
                }], (elements = ofArray([reactApi_1.createElement(YAxis, {}), reactApi_1.createElement(Tooltip, {}), reactApi_1.createElement(XAxis, {
                    dataKey: "Dato",
                }), reactApi_1.createElement(Line, {
                    dataKey: "Antall",
                    stroke: "hsl(207.3, 30%, 28%)",
                    strokeWidth: 3,
                })]), ["children", reactApi.Children.toArray(Array.from(elements))])]), reactApi_1.createElement(LineChart, createObj(properties_7)))]]), reactApi_1.createElement(ResponsiveContainer, createObj(properties_8))));
            }));
        }
        else {
            return singleton(MuiHelpers_createElement(Skeleton, [["variant", "rectangular"], ["style", {
                width: 100 + "%",
                minHeight: 250,
                marginBottom: 30,
            }]]));
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function search(locale, onClose) {
    let elements_2, children, children_1;
    return MuiHelpers_createElement(Dialog, [["open", true], ["onClose", (_arg_1, v) => {
        onClose(undefined);
    }], (elements_2 = [MuiHelpers_createElement(DialogTitle, [["children", locale.t("Search")]]), (children = singleton_1(createElement(Search_1, {
        exclude: new Int32Array([]),
        onSelect: (arg) => {
            onClose(arg);
        },
    })), MuiHelpers_createElement(DialogContent, [["children", reactApi.Children.toArray(Array.from(children))]])), (children_1 = singleton_1(MuiHelpers_createElement(Button, [["size", "small"], ["variant", "outlined"], ["color", "primary"], ["children", locale.t("Cancel")], ["onClick", (_arg_2) => {
        onClose(undefined);
    }]])), MuiHelpers_createElement(DialogActions, [["children", reactApi.Children.toArray(Array.from(children_1))]]))], ["children", reactApi.Children.toArray(Array.from(elements_2))])]);
}

export function View() {
    let elems_1;
    const ctx = reactApi.useContext(ctx_1);
    let patternInput;
    const arg_1 = init();
    patternInput = reactApi.useReducer(update, arg_1);
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    useEffectOnce(() => {
        let matchValue, matchValue_1;
        fetchDaily((matchValue = model_1.SelectedCustomer, (matchValue != null) ? matchValue.Id : undefined), dispatch);
        fetchSummary((matchValue_1 = model_1.SelectedCustomer, (matchValue_1 != null) ? matchValue_1.Id : undefined), dispatch);
        const matchValue_2 = model_1.SelectedCustomer;
        if (matchValue_2 != null) {
            fetchCustomerUsage(matchValue_2.Id, dispatch);
        }
    });
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 30 + "px",
    }], (elems_1 = toList(delay(() => append(singleton(createElement(SnackError, {
        errMsg: unwrap(model_1.ErrorMsg),
        dismiss: () => {
            dispatch(new Message(5, []));
        },
    })), delay(() => append(model_1.Search ? singleton(search(ctx.Locale, (customer) => {
        if (customer != null) {
            const c_2 = customer;
            fetchDaily(c_2.Id, dispatch);
            fetchSummary(c_2.Id, dispatch);
            fetchCustomerUsage(c_2.Id, dispatch);
            dispatch(new Message(3, [c_2]));
        }
        else {
            dispatch(new Message(4, [false]));
        }
    })) : empty_1(), delay(() => {
        let elems, matchValue_3;
        return append(singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            gap: 15 + "px ",
            marginBottom: 20,
        }], (elems = [createElement(Components_Button_Z1043B8E, {
            text: (matchValue_3 = model_1.SelectedCustomer, (matchValue_3 != null) ? matchValue_3.Name : ctx.Locale.t("Dashboard.Usage.SeeActivityForCustomer")),
            onClick: (_arg_2) => {
                dispatch(new Message(4, [true]));
            },
            startIcon: (model_1.SelectedCustomer != null) ? ((props) => {
                const props_2 = createObj(props);
                return react.createElement(Person, props_2);
            }) : ((props_3) => {
                const props_5 = createObj(props_3);
                return react.createElement(Search_2, props_5);
            }),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => append(singleton(drawSummary(ctx.Locale, model_1)), delay(() => append((model_1.SelectedCustomer != null) ? singleton(drawCustomerSummary(ctx.Locale, model_1)) : empty_1(), delay(() => singleton(drawDailyUsage(ctx.Locale, model_1))))))));
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

